/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileResponse } from '../../models/profile-response';

export interface GetUserProfilesWhereIsReporter$Params {

/**
 * Id of user.
 */
  id: number;
}

export function getUserProfilesWhereIsReporter(http: HttpClient, rootUrl: string, params: GetUserProfilesWhereIsReporter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileResponse>>> {
  const rb = new RequestBuilder(rootUrl, getUserProfilesWhereIsReporter.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileResponse>>;
    })
  );
}

getUserProfilesWhereIsReporter.PATH = '/rest/user/{id}/profile/reporter';
